// Paleta de marca (rebranding Sol Agora / Ombrello). Espelha
// src/assets/_colors.scss — usar aqui só onde SCSS não alcança
// (ex: opções do SweetAlert2, que recebem cor como string em runtime).
export const BRAND_COLORS = {
  horizonte500: '#00A3E0',
  horizonte700: '#006E97',
  noturno500: '#041C2C',
  noturno300: '#547080',
  // Material Design red-500 padrão — usado nos ícones de erro do SweetAlert2.
  red500: '#F44336',
} as const;
